import React, { useRef, useState } from 'react'
import { ButtonGroup, Button, Modal, Form, ToggleButton } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setButSign, setTabplateStoAll, setZidingStoTi } from '../../store/modules/tabplate';
import { setIncrementSec, setSec } from "../../store/modules/timerslice";
import { setStartTimer, setStopTimer } from "../../store/modules/timerId";
import { serGetTimu } from "../../axios";
import Alertwin from '../Alertwin';
import langList from "../../utils/languagelist.json";
import { setHelpContent } from '../../store/modules/helpinfo';

function isSudoku(str) {
  let grid = [];
  // 将字符串转换为九宫格数组
  for (let i = 0; i < 9; i++) {
    grid.push([]);
    for (let j = 0; j < 9; j++) {
      grid[i][j] = parseInt(str.charAt(i * 9 + j));
    }
  }
  // 验证每一行
  for (let i = 0; i < 9; i++) {
    let row = grid[i];
    if (!isValidArray(row)) {
      return false;
    }
  }
  // 验证每一列
  for (let j = 0; j < 9; j++) {
    let column = [];
    for (let i = 0; i < 9; i++) {
      column.push(grid[i][j]);
    }
    if (!isValidArray(column)) {
      return false;
    }
  }
  // 验证每一宫
  for (let i = 0; i < 9; i += 3) {
    for (let j = 0; j < 9; j += 3) {
      let box = [];
      for (let m = i; m < i + 3; m++) {
        for (let n = j; n < j + 3; n++) {
          box.push(grid[m][n]);
        }
      }
      if (!isValidArray(box)) {
        return false;
      }
    }
  }
  // 数组验证函数，判断数组中的元素是否符合数独规则
  function isValidArray(array) {
    let nums = new Set();
    for (let i = 0; i < 9; i++) {
      let num = array[i];
      if (nums.has(num)) {
        return false;
      } else if (num !== 0) {
        nums.add(num);
      }
    }
    return true;
  }
  return true;
};

function formatTime(time) {
  // 格式化时间
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = time % 60;

  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
};

function defaultTableDate(){
  const tabledate={t0:0,tt:[],ti:"0",btn:""}
  for(let i=0;i<81;i++){
    const cell={nu:["0","0","b0b0b0b0b0b0b0b0b0"],bj:"0",sc:["0","0","0","0","0","0","0","0","0"],sh:0}
    tabledate.tt.push(cell)
  }
  return tabledate
}

export default function Buttbar() {

  const [show, setShow] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [digitCount, setDigitCount] = useState(0);
  const [spanDis,setSpanDis]=useState(false) ;
  const [spanTxt,setSpanTxt]=useState('');
  
  const [popoverTitle, setPopoverTitle] = useState({});

  const {btn}=useSelector((state)=>state.tabplate);
  const {lg}=useSelector((state)=>state.language);
  const {sec}=useSelector((state)=>state.timerslice);
  const {timerId}=useSelector((state)=>state.timerId);
  const {expires}=useSelector((state)=>state.logininfo);
  const dispatch=useDispatch();

  const selB = btn;
  const time = sec;

  const tarbs = useRef([
    React.createRef(), React.createRef(), React.createRef(),
    React.createRef(), React.createRef(), React.createRef()
  ]);

  function startTimer() {
    if (timerId) return;
    const id = setInterval(() => {
      dispatch(setIncrementSec());
    }, 1000);
    dispatch(setStartTimer(id));
  };

  function stopTimer () {
    if (timerId) {
      clearInterval(timerId);
      dispatch(setStopTimer());
    };
  };

  const handleClick = (buttonValue) => {
    if (Object.keys(popoverTitle).length !== 0){
      return;
    };
    dispatch(setButSign({btn:buttonValue}));
    if(buttonValue==='b6'){
      setShow(true);
    }else{
      serGetTimu({btn:buttonValue})
      .then(res =>{
        dispatch(setZidingStoTi({str:res.data,btn:buttonValue}));
        dispatch(setSec(0))
        // 帮助文档设为初始
        dispatch(setHelpContent({flag:0,content:'',id:0,node:null,nodeold:null}))
        startTimer();
      })
      .catch(err =>{
        const mark = err.code === 100 ? 1 : 2
        const message = err.code === 100 ? `${langList.buttbar7[lg]}` : err.message
        console.log(1,selB)
        setPopoverTitle({mark:mark,message:message})
      });
    };
  };

  const handleTimeClick = () => {
    if (!timerId) {
      startTimer();
    }else{
      stopTimer();
    };
  }

  // 弹出式对话的事件
  const handleClose = () => setShow(false);
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    // 只统计数字数量
    const v = (value.match(/A:(.*?)#/) || [null, value])[1];
    const digits = v.match(/(\{\d+\}|\[\d+\]|\d)/g);
    const count = digits ? digits.length : 0;
    setDigitCount(count);
  };
  const handleFormSubmit = () => {
    if(digitCount<81){
      setSpanTxt(`${langList.buttbar8[lg]}`);
      setSpanDis(true);
      return
    }
    if(digitCount>81){
      setSpanTxt(`${langList.buttbar9[lg]}`);
      setSpanDis(true);
      return
    }
    try{
      const match=inputValue.match(/A:(.*?)#/)
      if(match&&expires<Date.now()){
        setSpanTxt(`${langList.buttbar12[lg]}`);
        setSpanDis(true);
        return
      };
      const iValue=inputValue.replace(/[^\d]/g, "");
      const arr=match?match[1].match(/(\{\d+\}|\[\d+\]|\d)/g):iValue.split('');
      const strti=match?arr.map(v=>(v[0]==='{'||v[0]==='[')?'0':v).join(''):iValue;
      if(!isSudoku(strti)){
        setSpanTxt(`${langList.buttbar10[lg]}`);
        setSpanDis(true);
        return
      }
      const tabdata=defaultTableDate();
      tabdata.btn='b6';
      tabdata.ti=strti;
      for(let i=0;i<81;i++){
        if(arr[i][0]==='{'){
          const hx=['b0','b0','b0','b0','b0','b0','b0','b0','b0'];
          arr[i].slice(1,-1).split('').forEach(c=>hx[c*1-1]='b'+c)
          tabdata.tt[i].nu[2]=hx.join('')
          tabdata.tt[i].sh=3
        }else if(arr[i][0]==='['){
          tabdata.tt[i].nu[1]='b'+arr[i].slice(1,-1)
          tabdata.tt[i].sh=2
        }else if(/^[1-9]$/.test(arr[i])){
          tabdata.tt[i].nu[0]='b'+arr[i]
          tabdata.tt[i].sh=1        
        }
      }
      dispatch(setTabplateStoAll(tabdata));
      if(match){
        const matchcon=inputValue.match(/D:(.*?)#/);
        const content=matchcon?matchcon[1].replace('@','<br/>'):`${langList.buttbar14[lg]}`;
        const matchsn=inputValue.match(/B:(.*?)#/);
        const strsn=matchsn?matchsn[1].match(/[0-8]{2}(?:\{[1-9]+\}|\[[1-9]\]|[0-9])/g):[];
        const sn=strsn.map(v=>[v[0]*1,v[1]*1,'r'+
          (v[2]*1?v[2]:v[2]==='{'?v.slice(2).slice(1,-1):v[2]==='['?v.slice(2).slice(1,-1):'0')]);
        const matchtn=inputValue.match(/C:(.*?)#/)
        const strtn=matchtn?matchtn[1].match(/[0-8]{2}(?:\{[1-9]+\}|\[[1-9]\]|[0-9])/g):[];
        const tn=strtn.map(v=>[v[0]*1,v[1]*1,'r'+(v[2]==='{'?v.slice(2).slice(1,-1):'0')]);
        const id=0
        const nodde={sn,tn}
        dispatch(setHelpContent({flag:2,content,id,node:nodde,nodeold:nodde}))
      }else{
        dispatch(setHelpContent({flag:0,content:'',id:0,node:null,nodeold:null}))
      }
      handleClose();
      dispatch(setSec(0))
      startTimer();
    }catch(err){
      setSpanTxt(`${langList.buttbar13[lg]}`);
      setSpanDis(true);
      return
    }
  };
  const onfocusControl = () => {
    if (spanDis) {setSpanDis(false);}
  }

  if (Object.keys(popoverTitle).length !== 0) {
    setTimeout(() => {
      setPopoverTitle({});
    }, 5000);
  }

  return (
    <div className="d-flex justify-content-between">
      <ButtonGroup size="sm">
        <Button
          ref={tarbs.current[0]}
          variant={selB === "b1" ? "info" : "outline-info"}
          onClick={() => handleClick("b1")}
          style={{wordBreak: 'break-all'}}
        >{langList.buttbar1[lg]}</Button>
        <Button
          ref={tarbs.current[1]}
          variant={selB === "b2" ? "success" : "outline-success"}
          onClick={() => handleClick("b2")}
          style={{wordBreak: 'break-all'}}
        >{langList.buttbar2[lg]}</Button>
        <Button
          ref={tarbs.current[2]}
          variant={selB === "b3" ? "warning" : "outline-warning"}
          onClick={() => handleClick("b3")}
          style={{wordBreak: 'break-all'}}
        >{langList.buttbar3[lg]}</Button>
        <Button
          ref={tarbs.current[3]}
          variant={selB === "b4" ? "danger" : "outline-danger"}
          onClick={() => handleClick("b4")}
          style={{wordBreak: 'break-all'}}
        >{langList.buttbar4[lg]}</Button>
        <Button
          ref={tarbs.current[4]}
          variant={selB === "b5" ? "secondary" : "outline-secondary"}
          onClick={() => handleClick("b5")}
          style={{wordBreak: 'break-all'}}
        >{langList.buttbar5[lg]}</Button>
        <Button
          ref={tarbs.current[5]}
          variant={selB === "b6" ? "dark" : "outline-dark"}
          onClick={() => handleClick("b6")}
          style={{wordBreak: 'break-all'}}
        >{langList.buttbar6[lg]}</Button>
      </ButtonGroup>
      <ToggleButton
        variant="outline-dark"
        id='togbutton'
        className='d-flex align-items-center'
        onClick={handleTimeClick}
      >{formatTime(time)}</ToggleButton>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{langList.tikuadd7[lg]}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" id="formBasicEmail">
              <Form.Label htmlFor='buttbar'>
                {langList.buttbar11[lg]}003090620000100800...
              </Form.Label>
              <Form.Control
                as="textarea"
                id='buttbar'
                rows={2}
                type="text"
                placeholder={langList.tikuadd7[lg]}
                value={inputValue}
                onChange={handleInputChange}
                autoFocus
                onFocus={onfocusControl}
              />
            </Form.Group>
            <div style={{ color: digitCount === 81 ? "blue" : "red" }}>
              {langList.tikuadd8[lg]}{digitCount}
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          {spanDis && (<span style={{ color: "red" }}>{spanTxt}</span>)}
          <Button variant="primary" onClick={handleFormSubmit} className='w-auto'>
            {langList.public9[lg]}
          </Button>
        </Modal.Footer>
      </Modal>

      {Object.keys(popoverTitle).length !== 0 && 
      <Alertwin nu={{
        target:tarbs.current[parseInt(selB.substring(1))-1],
        place:"bottom",
        title:popoverTitle.message,
        mark:popoverTitle.mark
      }}/>
      }
      
    </div>
  );
}
